import { TCalendarBooking } from "../../types/types";

export const BookingExcerpt = (props: { booking: TCalendarBooking, selectBookingToView: Function, viewType: string }) => {

    let st = "";
    if (props.booking.paid) {
        st = "confirmed-booking confirmed-booking-bg";
    }

    return (<div key={props.booking.booking_id} className={"booking-excerpt col-auto "+st} onClick={() => props.selectBookingToView(props.booking)}>
        {props.booking.lodging_name} [{props.booking.booking_id}]
    </div>);
};